/* WebSocket helper for real-time presence. */
import { getToken } from "./api";

export function openPresenceSocket(childId, onMessage) {
  const backend = process.env.REACT_APP_BACKEND_URL;
  if (!backend) return null;
  const wsUrl =
    backend.replace(/^http/, "ws") + `/api/ws/presence/${childId}?token=${encodeURIComponent(getToken() || "")}`;
  let socket;
  let closed = false;
  let retryTimer = null;

  const connect = () => {
    socket = new WebSocket(wsUrl);
    socket.onmessage = (ev) => {
      try {
        onMessage(JSON.parse(ev.data));
      } catch (_) {
        // ignore
      }
    };
    socket.onclose = () => {
      if (!closed) {
        // gentle reconnect with backoff
        retryTimer = setTimeout(connect, 4000);
      }
    };
    socket.onerror = () => {
      try {
        socket.close();
      } catch (_) {
        // ignore
      }
    };
  };

  connect();
  return () => {
    closed = true;
    if (retryTimer) clearTimeout(retryTimer);
    if (socket && socket.readyState !== WebSocket.CLOSED) {
      try {
        socket.close();
      } catch (_) {
        // ignore
      }
    }
  };
}
